import { render, staticRenderFns } from "./AamsDocumentBaseDispatchCode.vue?vue&type=template&id=50e79bce&scoped=true&"
import script from "./AamsDocumentBaseDispatchCode.vue?vue&type=script&lang=js&"
export * from "./AamsDocumentBaseDispatchCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e79bce",
  null
  
)

export default component.exports